<div class="pcl-control-label mat-dialog-title">
  <span>Change location?</span>
</div>
<div
  class="mat-dialog-content"
  [class.dialog-width-auto]="breakpointService.isMobile"
  [class.dialog-width-400]="!breakpointService.isMobile">
  <p>{{ message }}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>No, stay here</button>
  <button mat-flat-button color="primary" (click)="onChangeLocale()">Yes, switch</button>
</div>
